<template>
  <v-menu v-model="menuShown" bottom offset-y content-class="header-menu">
    <template #activator="{ on }">

      <div class="d-flex" v-on="on" v-if="!isMobileOnly">

        <app-tooltip left :containerClass="'overflow-hidden'">

          <div class="d-flex align-center user-name overflow-hidden">

            <div class="d-flex overflow-hidden">
              <div class="overflow-hidden">
                <div class="text-subtitle-1 text-truncate">
                  {{userName}}
                </div>
                <div v-if="isMyOrganizationSelected" class="text-truncate primary--text text-caption">
                  {{ selectedMyOrganization.name }}
                </div>
              </div>
              <v-icon color="primary" class="ml-1">fa-angle-down</v-icon>
            </div>

            <div class="d-flex">
              <v-divider vertical class="mx-2 divider-transparent"></v-divider>
              <v-avatar v-if="userAvatar" color="grey lighten-4" class="mr-2 overflow-hidden header-menu-user-avatar">
                <img :src="userAvatar">
              </v-avatar>
              <v-avatar v-else color="grey lighten-4" class="mr-2 header-menu-user-avatar">
                <span>{{userName.substr(0, 1) | upper }}</span>
              </v-avatar>
            </div>

          </div>

          <template v-slot:tooltip>
            {{userName}}
            <span v-if="isMyOrganizationSelected"><br />{{selectedMyOrganization.name}}</span>
            <span v-if="!isMyOrganizationSelected && orgnizationName"><br />{{orgnizationName}}</span>
          </template>

        </app-tooltip>

      </div>

      <div v-if="isMobileOnly">
        <v-avatar v-if="userAvatar" color="grey lighten-4" class="mr-2 overflow-hidden header-menu-user-avatar" v-on="on">
          <img :src="userAvatar" class="header-mobile-avatar">
        </v-avatar>
        <v-avatar v-else color="grey lighten-4" class="mr-2 header-menu-user-avatar" v-on="on">
          <span>{{userName.substr(0, 1) | upper }}</span>
        </v-avatar>
      </div>

    </template>

    <div class="userInfo">
      <div style="text-align: center" class="pa-3">
        <span class="emailUser">{{userEmail}}</span>
      </div>
      <div v-if="isMonetizationEnabled" class="userDelivery pa-3">
        <div class="d-flex justify-space-between">
          <span class="totalDelivery">{{$t('common.deliverytooltip.totalDelivery')}}</span>
          <span class="payedDocs">{{availableDeliveriesTotal}}</span>
        </div>
        <div class="d-flex justify-space-between">
          <span>{{$t('common.deliverytooltip.paid')}}</span>
          <span class="payedDocs">{{availableAdditionalDeliveries}}</span>
        </div>
        <div class="d-flex justify-space-between">
          <span>{{$t('common.deliverytooltip.free')}}</span>
          <span class="freeDocs">{{availableTariffPlanDeliveries}}</span>
        </div>
        <div class="text-center">
          <span class="tariffLink" @click="showTariffPage"><a>{{$t('common.deliverytooltip.replenishBalance')}}</a></span>
        </div>
      </div>
    </div>

    <div class="list-wrapper" :class="[ isMobileOnly ? 'mobile' : '']">

      <div v-for="(item, index) in menuItems" :key="index">

        <div v-if="item.type==='item'" class="d-flex pa-3 clickable header-menu-item" :disabled="item.disabled" v-show="!item.hide"
          @click="selectMenu(item)">
          <div class="mr-3">
            <v-icon style="width: 20px; height: 20px;">{{ item.icon }}</v-icon>
          </div>
          <div class="flex-grow-1">
            {{item.title}}
          </div>
        </div>

        <v-menu v-if="item.type==='menu'" content-class="app-menu" offset-x :open-on-hover="!isMobile" :open-delay="isMobile ? 0 : 300"
          v-bind="item.attrs">

          <template v-slot:activator="{ on }">
            <div v-on="on" class="d-flex pa-3 clickable header-menu-item">
              <div class="mr-3">
                <v-icon style="width: 20px; height: 20px;">{{ item.icon }}</v-icon>
              </div>
              <div class="flex-grow-1">
                {{item.title}}
              </div>
              <div>
                <v-icon x-small style="width: 20px; height: 20px;">fa-chevron-down</v-icon>
              </div>
            </div>
          </template>

          <v-list dense>
            <div v-for="(item2, index) in item.items" :key="index">
              <v-divider v-if="item2.type==='divider'"></v-divider>
              <v-list-item v-if="item2.type==='item'" :disabled=" item2.disabled" @click.native.stop v-show="!item2.hide"
                @click="selectMenu(item2)" class="header-menu-item">
                <v-list-item-avatar v-if="item2.icon">
                  <v-icon style="width: 20px; height: 20px;">{{ item2.icon }}</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  {{item2.title}}
                </v-list-item-content>
              </v-list-item>
            </div>
          </v-list>

        </v-menu>

        <div v-if="item.type==='divider'">
          <v-divider></v-divider>
        </div>
      </div>

    </div>
  </v-menu>
</template>

<script>
import get from 'lodash/get';
import { actions as _act } from '@/models/store.actions';
import AppTooltip from '@/components/Common/AppTooltip';
import { getLocaleR } from '@/helpers/';
import { globalSettingsHelper } from '@/helpers/settings-helper';
import { Languages } from '@/models/enums';
import { permissionsHelper } from '@/helpers/permissions.helper';
import { businessHelper } from '@/helpers/business.helper';

export default {
  name: 'HeaderMenu',
  components: { AppTooltip },
  inject: ['isMobile', 'baseUrl', 'isMobileOnly'],
  data: () => ({
    langs: [Languages.Ukrainian, Languages.English],
    menuShown: false
  }),
  computed: {
    userEmail() {
      return this.$store.getters[_act.AUTH_GET_EMAILUSERGET];
    },
    userName() {
      return this.$store.getters[_act.AUTH_GET_LOGINUSERGET];
    },
    balance() {
      return this.$store.getters[_act.DOC_GET_BALANCE];
    },
    allowViewTariffs() {
      return this.$store.getters[_act.AUTH_GET_ACTIONSGET].includes(10900);
    },
    locale() {
      return this.$store.getters[_act.SETT_GET_LOCALEGET];
    },
    menuItems() {
      let lang = this.$store.getters[_act.SETT_GET_LOCALEGET];
      let actions = this.$store.getters[_act.AUTH_GET_ACTIONSGET];
      let orgItems = [];
      if (
        permissionsHelper.isAllowedToViewOrganisationDepartments ||
        permissionsHelper.isAllowedToViewOrganisationRoles ||
        permissionsHelper.isAllowedToViewOrganisationUsers ||
        businessHelper.isAllowedToViewOrganisationInvitations ||
        businessHelper.isAllowedToViewMyOrganisations ||
        permissionsHelper.isAllowedToViewOrganisationContragents ||
        permissionsHelper.isAllowedToViewOrganisationBlanks ||
        permissionsHelper.isAllowedToViewOrganisationSettings
      ) {
        orgItems = [
          {
            type: 'item',
            id: 'organization',
            title: getLocaleR('header.menu.orgSettings', lang),
            icon: 'fa-cog'
          }
        ];
        if (businessHelper.isAllowedToViewMyOrganisations) {
          const myOrgMenuItems = [
            {
              type: 'item',
              id: 'selectMyOrganization',
              title: getLocaleR('header.menu.selectMyOrganization', lang),
              icon: ''
            },
            { type: 'divider' },
            {
              type: 'item',
              id: 'allMyOrganization',
              title: getLocaleR('header.menu.allMyOrganization', lang),
              icon: this.isMyOrganizationSelected ? '' : 'fa-check',
              disabled: !this.isMyOrganizationSelected
            }
          ];

          if (this.isMyOrganizationSelected) {
            myOrgMenuItems.push({
              type: 'item',
              id: 'selectedMyOrganization',
              title: this.selectedMyOrganization.name,
              icon: 'fa-check',
              disabled: true
            });
          }
          orgItems.push({
            type: 'menu',
            id: 'myOrganization',
            title: getLocaleR('header.menu.myOrganization', lang),
            icon: 'fa-th',
            items: myOrgMenuItems,
            attrs: {
              maxWidth: '250px'
            }
          });
        }
      }
      let refLinksItems = [];
      if (this.isMobileOnly && globalSettingsHelper.isReferralLinkEnabled && actions.includes(14000)) {
        refLinksItems = [{
          type: 'item',
          id: 'referralLinks',
          title: getLocaleR('header.menu.referralLinks', lang),
          icon: 'fa-user-plus'
        }];
      }
      return [
        {
          type: 'item',
          id: 'cabinet',
          title: getLocaleR('header.menu.cabinet', lang),
          icon: 'fa-user'
        },
        ...orgItems,
        {
          type: 'menu',
          id: 'language',
          title: getLocaleR('header.menu.language', lang, {
            current: `(${this.locale.toUpperCase()})`
          }),
          items: this.langs
            .filter((l) => l !== this.locale)
            .map((l) => {
              return { type: 'item', id: 'language', title: l, value: l };
            }),
          icon: 'fa-globe'
        },
        {
          type: 'item',
          id: 'logs',
          title: getLocaleR('header.menu.messages', lang),
          icon: 'fa-exclamation-circle'
        },
        ...refLinksItems,
        { type: 'divider' },
        {
          type: 'item',
          id: 'contacts',
          title: getLocaleR('header.menu.contacts', lang),
          icon: 'fa-envelope'
        },
        {
          type: 'item',
          id: 'support',
          title: getLocaleR('header.menu.support', lang),
          icon: 'fa-headphones'
        },
        { type: 'divider' },
        {
          type: 'item',
          id: 'logout',
          title: getLocaleR('header.menu.logout', lang),
          icon: 'fa-sign-out-alt'
        }
      ];
    },
    orgnizationName() {
      return this.$store.getters[_act.AUTH_GET_ORGGET];
    },
    userAvatar() {
      return this.$store.getters[_act.AUTH_GET_AVATAR];
    },
    selectedMyOrganization() {
      return this.$store.getters[_act.ORG_GET_MYORG];
    },
    isMyOrganizationSelected() {
      return !!this.selectedMyOrganization.code;
    },
    availableAdditionalDeliveries() {
      return (this.balance ? this.balance.deliveryAdd : 0) || 0;
    },
    availableTariffPlanDeliveries() {
      return (this.balance ? (this.balance.deliveryFreeCur + this.balance.deliveryCredit) : 0) || 0;
    },
    availableDeliveriesTotal() {
      return this.availableAdditionalDeliveries + this.availableTariffPlanDeliveries;
    },
    appSettings() {
      return this.$store.getters[_act.SETT_GET_APPSET];
    },
    workMode() {
      return +(get(this, 'appSettings.globalSettings.globalSettingItems.workmode.settingValue') || '0');
    },
    isMonetizationEnabled() {
      return this.workMode === 0;
    }
  },
  methods: {
    selectMenu(item) {
      this.menuShown = false;
      this.$emit('onselectmenu', item);
    },
    showTariffPage() {
      if (this.allowViewTariffs && this.$route.path !== '/cabinet/tariffs') {
        this.$router.push('/cabinet/tariffs');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/common.scss';

.header-menu {
  @extend .menu-with-top-edging;

  &::before {
    right: 12px;
  }

  .userInfo {
    .emailUser {
      margin: auto;
      font-weight: 500;
      font-size: 14px;
      color: var(--v-info-darken3);
    }
    .userDelivery {
      background-color: rgba(240, 251, 246, 1);
      span {
        font-weight: 600;
        font-size: 14px;
        padding-bottom: 0.5em;
      }
      .freeDocs {
        color: var(--v-accent-base);
      }
      .payedDocs {
        color: var(--v-primary-base);
      }
      .tariffLink {
        cursor: pointer;
        text-decoration: underline;
        padding-bottom: 0px;
        a {
          color: var(--v-secondary-base);
        }
      }
    }
  }
  .list-wrapper:not(.mobile) {
    width: 300px;
  }
  .header-mobile-avatar {
    height: 100%;
    width: 100%;
  }
}
.header-menu-item:hover {
  &,
  .v-icon,
  .v-image,
  .v-list-item__content {
    color: var(--v-primary-base);
  }
}
.header-menu-user-avatar {
  background-image: linear-gradient(to bottom, #328BF0 50%, #FFC700 50%);
  img {
    border: 3px solid transparent;
  }
}
</style>
